module.exports = __webpack_public_path__ + "static/img/Application_Interaction_Example.24bc4060.png";